import { useMemo } from 'react';

import {
  generateImpressionForDifferentialPricing,
  previewImpressionForDifferentialPricing,
  previewImpressionForSelfServeInvoicing,
} from 'bundles/teams-v2/utils/experimentUtils';

/**
 * A hook to determine if differential pricing is enabled
 * @returns true / false indicating whether differential pricing is enabled or not
 */
function useIsDifferentialPricingEnabled(generateImpression?: boolean) {
  const isSelfServeInvoiceFlow = previewImpressionForSelfServeInvoicing();

  return useMemo(() => {
    // Differential pricing is disabled for self-serve invoicing flow
    if (isSelfServeInvoiceFlow) {
      return false;
    }

    if (generateImpression) {
      return generateImpressionForDifferentialPricing();
    }

    return previewImpressionForDifferentialPricing();
  }, [generateImpression, isSelfServeInvoiceFlow]);
}

export default useIsDifferentialPricingEnabled;
